import cookie from '../cookie';
import { VIDEO_COOKIES } from './config';
import { getDomain } from './lib';

/**
 * 清除所有视频 cookie
 */
export function clearVideoCookies(domain = 'qq.com') {
  VIDEO_COOKIES.forEach((key) => {
    cookie.remove(key, {
      domain,
      path: '/',
    });
  });
}

/**
 * 清除 qq.com 域下的 cookie 信息
 * 一般用于非 app 场景，如果存在 qq.com 的 cookie，会导致与 video.qq.com 源 cookie 冲突
 */
export function clearRootDomainCookies() {
  clearVideoCookies('qq.com');
}

/**
 * 清除当前域下的 cookie 信息
 */
export function clearPageCookies() {
  clearVideoCookies(getDomain());
}

/**
 * 判断当前是否是 Native 登录环境
 * @returns {Boolean}
 */
export function isNativeLogin() {
  return /video_platform=[3-6]/.test(document.cookie);
}
